// @Todo : Remove this file when ff4j "header-v2" is cleaned
import {allowUserScroll, preventUserScroll} from '../../services/preventUserScroll';
import {open, closed, clickOnPremobileButton} from '../../../events/header';
import {AWESOMEPLETE_OPEN, AWESOMEPLETE_CLOSE} from '../../../events/autocomplete';

const HEADER_SEARCH_CLASSES = {
    opened: 'OPENED',
    invisible: 'INVISIBLE',
    focus: 'FOCUSED',
    valid: 'VALID',
};

Hop.defineModule('main-header-search', (domRoot, param) => {
    const domAwesomPlete = domRoot.querySelector('[data-awesomplete-input]');
    const domHeaderOpenSearch = domRoot.querySelectorAll('.js-open-header-search');
    const domHeaderSearchBtn = domRoot.querySelectorAll('.js-search-home-btn');
    const domHeaderCloseSearch = domRoot.querySelector('[data-close-mobile-search]');
    const domMobileSearch = domRoot.hasAttribute('data-search-block-mobile');

    const MOBILE_SEARCH_BREAKPOINT = 1200;
    const PRE_MOBILE_MODE_BREAKPOINT = 1440;
    const MOBILE_FAKE_SEARCH_BTN_BREAKPOINT = 768;

    const debouncedOnResize = Hop.debounce(windowResizeListeners, 30);
    const debouncedOnScroll = Hop.debounce(toggleSearchVisibilityOnScroll, 50);

    let scrollLimWidthWithDoubleSearch = scrollLimWithDoubleSearchBehaviour();

    function windowResizeListeners() {
        resetScrollLimWidthWithDoubleSearch();
        hideSearchOnPreMobileMode('resize');
        hideMobileSearchOnResize();
    }

    function mediaHigherThanBreakpoint(minOrMax = 'min') {
        return matchMedia(`(${minOrMax}-width:${MOBILE_SEARCH_BREAKPOINT}px)`).matches;
    }

    function isPreMobileMode() {
        return matchMedia(`(max-width: ${PRE_MOBILE_MODE_BREAKPOINT}px)`).matches && matchMedia(`(min-width: ${MOBILE_SEARCH_BREAKPOINT}px)`).matches;
    }

    function hasToBeOpenedByDefault() {
        return param.openedByDefault && mediaHigherThanBreakpoint();
    }

    function scrollLimWithDoubleSearchBehaviour() {
        if (matchMedia(`(min-width: ${MOBILE_FAKE_SEARCH_BTN_BREAKPOINT}px)`).matches) {
            // #q is out of the module, comes from homepage searchbar
            const searchInput = document.querySelector('#q');
            return searchInput ? searchInput.offset().top + Hop.pageTop() : 500;
        } else {
            // same here, comes from homepage searchbar
            const searchBtn = document.querySelector('[data-trigger-search]');
            return searchBtn ? searchBtn.offset().top + Hop.pageTop() : 500;
        }
    }

    function resetInvalidFields() {
        if (Hop && Hop.formFn && Hop.formFn.removeSingleMessage) {
            Hop.formFn.removeSingleMessage('q2');
        }
    }

    function setSearchInvisible() {
        resetInvalidFields();
        domRoot.classList.remove(HEADER_SEARCH_CLASSES.opened);
    }

    function setSearchVisible() {
        domRoot.classList.add(HEADER_SEARCH_CLASSES.opened);
    }

    function focusOnFirstInputByDefault() {
        domAwesomPlete.focus();
    }

    function jobValueCheck() {
        domAwesomPlete.addEventListener('keyup', checkFormValidity);
    }

    function checkFormValidity(e) {
        domRoot.classList.toggle(HEADER_SEARCH_CLASSES.valid, domAwesomPlete.value.length >= 2);

        if (e && !e.target.value.length) {
            removeFocusClassOnJobInput();
        }
    }

    function removeFocusClassOnJobInput() {
        domAwesomPlete.classList.remove(HEADER_SEARCH_CLASSES.focus);
    }

    function setInputsAutompleteListener() {
        domRoot.addEventListener(AWESOMEPLETE_OPEN, addFocusClassOnJobInput);
        domAwesomPlete.addEventListener(AWESOMEPLETE_CLOSE, removeFocusClassOnJobInput);
    }

    function addFocusClassOnJobInput() {
        if (domAwesomPlete.nextSibling.childNodes.length) {
            domAwesomPlete.classList.add(HEADER_SEARCH_CLASSES.focus);
        }
    }

    function openSearch() {
        setSearchVisible();
        gtmPush();

        Hop.events.trigger(open);

        if (!mediaHigherThanBreakpoint()) {
            preventUserScroll();
        }

        domRoot.classList.add(HEADER_SEARCH_CLASSES.opened, HEADER_SEARCH_CLASSES.focus);

        if (!hasToBeOpenedByDefault()) {
            focusOnFirstInputByDefault();
        }
    }

    function closeSearch(e) {
        if (e) {
            e.preventDefault();
        }

        setSearchInvisible();
        if (param.doubleSearch && mediaHigherThanBreakpoint('max') && !scrollOverLimitForDoubleSearch()) {
            domRoot.classList.add(HEADER_SEARCH_CLASSES.invisible);
        }

        allowUserScroll();
        Hop.events.trigger(closed);
    }

    function resetScrollLimWidthWithDoubleSearch() {
        scrollLimWidthWithDoubleSearch = scrollLimWithDoubleSearchBehaviour();
    }

    function hideSearchOnPreMobileMode(eventType) {
        // We need to check how this function is triggered
        // because on mobile, userScroll.prevent() triggers a window resize event. And this event triggers this function and finally hide the search
        if (eventType && eventType === 'resize') {
            return;
        }

        if (isPreMobileMode() || mediaHigherThanBreakpoint('max')) {
            setSearchInvisible();
        }
    }

    function hideMobileSearchOnResize() {
        if (mediaHigherThanBreakpoint('min') && domMobileSearch) {
            domRoot.classList.remove(HEADER_SEARCH_CLASSES.opened, HEADER_SEARCH_CLASSES.focus);
        }
    }

    function setWindowResizeAndScrollListener() {
        window.addEventListener('resize', debouncedOnResize);
        if (param.doubleSearch) {
            window.addEventListener('scroll', debouncedOnScroll);
        }
    }

    function listenToClickOnNewOpenSearchButton() {
        domHeaderSearchBtn.forEach((btn) => {
            btn.addEventListener('click', openSearch);
        });
    }

    function listenToPremobileMenuOpen() {
        Hop.events.on(clickOnPremobileButton, setSearchInvisible);
    }

    function listenToMobileMenu() {
        // TODO FIX ME
        // Hop.events.on(clickOnMobileButton, setSearchInvisible);
    }

    function listenToMobileCloseSearch() {
        if (domHeaderCloseSearch) {
            domHeaderCloseSearch.addEventListener('click', closeSearch);
        }
    }

    function listenToNewHeaderUserActions() {
        setWindowResizeAndScrollListener();
        listenToClickOnNewOpenSearchButton();
        listenToPremobileMenuOpen();
        hideSearchOnPreMobileMode();
        listenToMobileCloseSearch();
        listenToMobileMenu();

        // First check when dom is ready, for search page
        checkFormValidity();
        jobValueCheck();

        if (mediaHigherThanBreakpoint('max')) {
            // If mobile
            setInputsAutompleteListener();
        }

        if (hasToBeOpenedByDefault()) {
            setSearchVisible();
        }

        if (param.doubleSearch) {
            toggleSearchVisibilityOnScroll();
        }
    }

    function gtmPush() {
        Hop.gtm.push({
            category: '_search',
            action: '_view_search',
            label: domHeaderSearchBtn[0].getAttribute('data-gtm-label'),
        });
    }

    function toggleSearchVisibilityOnScroll() {
        if (!document.body.classList.contains('PREVENT_USER_SCROLL')) {
            if (scrollOverLimitForDoubleSearch()) {
                domRoot.classList.remove(HEADER_SEARCH_CLASSES.invisible);
            } else {
                domRoot.classList.add(HEADER_SEARCH_CLASSES.invisible);
                domRoot.classList.remove(HEADER_SEARCH_CLASSES.opened);
            }
        }
    }

    function scrollOverLimitForDoubleSearch() {
        return Hop.pageTop() > scrollLimWidthWithDoubleSearch;
    }

    listenToNewHeaderUserActions();

    return function destroy() {
        domHeaderSearchBtn.forEach((btn) => {
            btn.removeEventListener('click', openSearch);
        });
        domHeaderOpenSearch.forEach((f) => f.removeEventListener('click', openSearch));

        if (domHeaderCloseSearch) {
            domHeaderCloseSearch.removeEventListener('click', closeSearch);
        }

        domAwesomPlete.removeEventListener('keyup', checkFormValidity);
        domAwesomPlete.removeEventListener(AWESOMEPLETE_OPEN, addFocusClassOnJobInput);
        domAwesomPlete.removeEventListener(AWESOMEPLETE_CLOSE, removeFocusClassOnJobInput);

        window.removeEventListener('resize', debouncedOnResize);
        if (param.doubleSearch) {
            window.removeEventListener('scroll', debouncedOnScroll);
        }
    };
});
